export const ORDERBY_FILTERS = {
	ASC: 'asc',
	DESC: 'desc',
};
